import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b05c9ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "手机号码", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#606266","font-size":"12px"} }, "我已阅读并同意", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_close_bold = _resolveComponent("close-bold")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_image, {
      style: {"width":"100%"},
      src: `${_ctx.FILESERVICE}/file/4pl/webclient/img/update-password-title-bg.png`,
      fit: "fill"
    }, null, 8, ["src"]),
    (_ctx.showCloseBtn)
      ? (_openBlock(), _createBlock(_component_close_bold, {
          key: 0,
          class: "close-icon",
          onClick: _ctx.onClose
        }, null, 8, ["onClick"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_form, {
      ref: "ruleForm",
      size: "large",
      class: "upd-password-form",
      style: {"padding":"25px 60px 32px 60px"},
      "label-position": "top",
      "hide-required-asterisk": "",
      model: _ctx.bindMobileData,
      rules: _ctx.rules,
      onKeydown: _withKeys(_ctx.onBindMobile, ["enter"])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { prop: "mobile" }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createVNode(_component_el_input, {
              modelValue: _ctx.bindMobileData.mobile,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.bindMobileData.mobile) = $event)),
              placeholder: "请输入手机号码",
              text: "",
              size: "large"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          prop: "verifyCode",
          class: "is-form-item"
        }, {
          default: _withCtx(() => [
            (!_ctx.countDownHidden)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  "aria-disabled": "true",
                  class: "is-mobile-code",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.getCode && _ctx.getCode(...args)))
                }, "发送验证码"))
              : (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: "is-mobile-disabled",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.getCode && _ctx.getCode(...args)))
                }, _toDisplayString(`${_ctx.countDown}s重新发送`), 1)),
            _createVNode(_component_el_input, {
              modelValue: _ctx.bindMobileData.verifyCode,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.bindMobileData.verifyCode) = $event)),
              placeholder: "请输入验证码",
              "show-password": "",
              size: "large"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_checkbox, {
          checked: _ctx.checked,
          onChange: _ctx.onChange
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _createElementVNode("span", {
              class: "is-reading-protocol",
              onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onReadingProtocol && _ctx.onReadingProtocol(...args)), ["prevent","stop"]))
            }, "《4PL平台隐私政策》")
          ]),
          _: 1
        }, 8, ["checked", "onChange"]),
        _createVNode(_component_el_button, {
          disabled: !_ctx.checked,
          type: "primary",
          size: "large",
          style: {"width":"100%"},
          onClick: _ctx.onBindMobile
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 确定 ")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      _: 1
    }, 8, ["model", "rules", "onKeydown"])
  ]))
}